import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <div class="application-loading">
    <PageLoading 
      @message="Loading 1vX.gg..." 
      @subtitle="The best way to watch eSports is loading"
      @size="large"
      class="application-loading__content"
    />
  </div>

  <style>
    .application-loading {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 2rem;
    }

    .application-loading__content {
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
      backdrop-filter: blur(8px);
    }

    /* Override the default background for this special case */
    .application-loading__content .page-loading {
      background-color: transparent;
    }
  </style>
</template>
);